import { atom } from 'jotai';

/**
 * When true, GlobalModalsWrapper does not render any global modals.
 * Set by pages that should not display global modals (e.g. mobile signup completion).
 */
export const globalModalsHiddenAtom = atom<boolean>(false);
